import { Injectable } from "@angular/core";

@Injectable()
export default class PatientBiometricsUpdate {
  constructor(
    public initialWeightKgs = "",
    public currentWeightKgs = "",
    public initialWeightLbs = "",
    public currentWeightLbs = "",
    public initialMmseScore = "",
    public currentMmseScore = "",
    public initialPpsScore = "",
    public currentPpsScore = "",
    public initialKarnofskyScore = "",
    public currentKarnofskyScore = "",
    public initialNyhaScore = "",
    public currentNyhaScore = "",
    public initialMuacScore = "",
    public currentMuacScore = "",
    public initialFastScore = "",
    public currentFastScore = "",
    public initialWeightDatetime = "",
    public currentWeightDatetime = "",
    public initialMmseScoreDatetime = "",
    public currentMmseScoreDatetime = "",
    public initialPpsScoreDatetime = "",
    public currentPpsScoreDatetime = "",
    public initialKarnofskyScoreDatetime = "",
    public currentKarnofskyScoreDatetime = "",
    public initialNyhaScoreDatetime = "",
    public currentNyhaScoreDatetime = "",
    public initialMuacScoreDatetime = "",
    public currentMuacScoreDatetime = "",
    public initialFastScoreDatetime = "",
    public currentFastScoreDatetime = ""
  ) {
    this.initialWeightKgs = initialWeightKgs;
    this.currentWeightKgs = currentWeightKgs;
    this.initialWeightLbs = initialWeightLbs;
    this.currentWeightLbs = currentWeightLbs;
    this.initialMmseScore = initialMmseScore;
    this.currentMmseScore = currentMmseScore;
    this.initialPpsScore = initialPpsScore;
    this.currentPpsScore = currentPpsScore;
    this.initialKarnofskyScore = initialKarnofskyScore;
    this.currentKarnofskyScore = currentKarnofskyScore;
    this.initialNyhaScore = initialNyhaScore;
    this.currentNyhaScore = currentNyhaScore;
    this.initialMuacScore = initialMuacScore;
    this.currentMuacScore = currentMuacScore;
    this.initialFastScore = initialFastScore;
    this.currentFastScore = currentFastScore;
    this.initialWeightDatetime = initialWeightDatetime;
    this.currentWeightDatetime = currentWeightDatetime;
    this.initialMmseScoreDatetime = initialMmseScoreDatetime;
    this.currentMmseScoreDatetime = currentMmseScoreDatetime;
    this.initialPpsScoreDatetime = initialPpsScoreDatetime;
    this.currentPpsScoreDatetime = currentPpsScoreDatetime;
    this.initialKarnofskyScoreDatetime = initialKarnofskyScoreDatetime;
    this.currentKarnofskyScoreDatetime = currentKarnofskyScoreDatetime;
    this.initialNyhaScoreDatetime = initialNyhaScoreDatetime;
    this.currentNyhaScoreDatetime = currentNyhaScoreDatetime;
    this.initialMuacScoreDatetime = initialMuacScoreDatetime;
    this.currentMuacScoreDatetime = currentMuacScoreDatetime;
    this.initialFastScoreDatetime = initialFastScoreDatetime;
    this.currentFastScoreDatetime = currentFastScoreDatetime;
  }
}



// WEBPACK FOOTER //
// ./src/models/idg/patient-biometrics-update.ts